<template>
 <div class="box">
  <div class="all">
    <div class="center">
      <div class="title">SCORE</div>
      <div class="num">{{score}}</div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'PaGe2',
  data() {
    return {
      score:0,
      timer:null
    }
  },
  beforeDestroy() {
    // 组件销毁时清除计时器
    clearInterval(this.timer);
  },
  mounted() {
    window.getMessage = this.getMessage;//获取推送数据
    this.score=this.$route.query.score;
    console.log(this.$route.query)
    this.timer=setTimeout(() => {
          this.$router.push({ path: '/page10'})
        }, 30000);
  }, methods: {
    getMessage(str) {
      const strs = str.split('-')
      if (strs[0] == 'start') {
      this.$router.push({ path: '/page10',query:{str:str} })
      }
      if (strs[0] == 'jump') {
      this.$router.push({ path: '/page3',query:{str:str} })
      }
    }
  }
}
</script>
<style scoped>
.box{
  width: 100%;
  height: 100vh;
  background: rgb(255, 0, 0);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
<style scoped>
.all {
  zoom: 0.5;
}
.all {
  width: 100%;
  background: rgb(255, 0, 0);
  height: 100vh;
  font-family: "bth";
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.title {
  font-size: 155px;
  color: #FFFFFF;
}

.num {
  font-size: 437px;
  color: #FFFFFF;
  height: 437px;
  line-height: 437px;
}
</style>
